"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectField = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _FormControl = _interopRequireDefault(require("react-bootstrap/lib/FormControl"));
var _FormControlFeedback = _interopRequireDefault(require("react-bootstrap/lib/FormControlFeedback"));
var _formFieldWrapper = require("../form-field-wrapper/form-field-wrapper");
var _excluded = ["id", "value", "label", "showLabel", "helpText", "valid", "invalid", "options", "defaultOptionLabel"];
var SelectField = exports.SelectField = function SelectField(_ref) {
  var id = _ref.id,
    value = _ref.value,
    label = _ref.label,
    showLabel = _ref.showLabel,
    helpText = _ref.helpText,
    valid = _ref.valid,
    invalid = _ref.invalid,
    options = _ref.options,
    defaultOptionLabel = _ref.defaultOptionLabel,
    selectProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var selectClasses = (0, _classnames["default"])('form-control select', {
    'select_unselected': !value
  });
  return /*#__PURE__*/_react["default"].createElement(_formFieldWrapper.FormFieldWrapper, {
    id: id,
    label: label,
    showLabel: showLabel,
    helpText: helpText,
    valid: valid,
    invalid: invalid
  }, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], (0, _extends2["default"])({}, selectProps, {
    value: value,
    className: selectClasses,
    componentClass: "select"
  }), defaultOptionLabel && /*#__PURE__*/_react["default"].createElement("option", {
    key: "option_default",
    disabled: true,
    value: ""
  }, defaultOptionLabel), Object.keys(options).map(function (key) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: key,
      value: key
    }, options[key]);
  })), /*#__PURE__*/_react["default"].createElement(_FormControlFeedback["default"], null, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "select__arrow"
  }))));
};